import { atom } from 'recoil';


const stateResultMode = atom({
    key: 'results.mode',
    default: 'biosamples'
});


export default stateResultMode;
